import { backdropClasses } from '@mui/material/Backdrop';

import { muiAlertOverrides } from './muiAlertOverrides';
import { muiAlertTitleOverrides } from './muiAlertTitleOverrides';
import { muiAppBarOverrides } from './muiAppBarOverrides';
import { muiAvatarOverrides } from './muiAvatarOverrides';
import { muiButtonOverrides } from './muiButtonOverrides';
import { muiCheckboxOverrides } from './muiCheckboxOverrides';
import { muiContainerOverrides } from './muiContainerOverrides';
import { muiDividerOverrides } from './muiDividerOverrides';
import { muiDrawerOverrides } from './muiDrawerOverrides';
import { muiFormControlLabelOverrides } from './muiFormControlLabelOverrides';
import { muiFormControlOverrides } from './muiFormControlOverrides';
import { muiFormGroupOverrides } from './muiFormGroupOverrides';
import { muiFormLabelOverrides } from './muiFormLabelOverrides';
import { muiIconButtonOverrides } from './muiIconButtonOverrides';
import { muiIconOverrides } from './muiIconOverrides';
import { muiInputBaseOverrides } from './muiInputBaseOverrides';
import { muiInputLabelOverrides } from './muiInputLabelOverrides';
import { muiLinkOverrides } from './muiLinkOverrides';
import { muiListItemOverrides } from './muiListItemOverrides';
import { muiListOverrides } from './muiListOverrides';
import { muiMenuItemOverrides } from './muiMenuItemOverrides';
import { muiMenuListOverrides } from './muiMenuListOverrides';
import { muiOutlinedInputOverrides } from './muiOutlinedInputOverrides';
import { muiPaperOverrides } from './muiPaperOverrides';
import { muiSelectOverrides } from './muiSelectOverrides';
import { muiSwitchOverrides } from './muiSwitchOverrides';
import { muiTablePaginationOverrides } from './muiTablePaginationOverrides';
import { muiTypographyOverrides } from './muiTypographyOverrides';

export const tsGoComponents = {
	MuiCssBaseline: {
		styleOverrides: {
			'*': {
				margin: 0,
				padding: 0,
				border: 'none',
				WebkitTapHighlightColor: 'transparent',
			},
			fieldset: {
				border: 'none',
				padding: 0,
				margin: 0,
			},
			ul: {
				margin: 0,
			},
			'ul:not([class]) li': {
				display: 'block',
				paddingLeft: '16px',
				position: 'relative',
				'&:before': {
					content: "''",
					position: 'absolute',
					left: '1px',
					top: '7.5px',
					width: '5px',
					height: '5px',
					backgroundColor: '#9ab1bb',
				},
			},
		},
	},
	MuiButtonBase: {
		defaultProps: {
			// The props to change the default for.
			disableRipple: true, // No more ripple, on the whole application 💣!
		},
	},
	MuiBackdrop: {
		styleOverrides: {
			root: {
				'&[style*="opacity: 0"]': {
					pointerEvents: 'none',
				},
			},
		},
	},
	MuiModal: {
		styleOverrides: {
			root: {
				[`&:has(> div.${backdropClasses.root}[style*="opacity: 0"])`]: {
					pointerEvents: 'none',
				},
			},
		},
	},
	MuiPaginationItem: {
		styleOverrides: {
			root: {
				color: 'rgb(15, 21, 26) !important',
				backgroundColor: 'inherit !important',

				['&.Mui-selected']: {
					fontWeight: '600 !important',
					color: 'rgb(0, 174, 255) !important',
				},

				['&.MuiPaginationItem-previousNext:not(.Mui-disabled), &.MuiPaginationItem-firstLast:not(.Mui-disabled)']: {
					color: 'rgb(0, 174, 255) !important',
				},
			},
		},
	},
	MuiTablePagination: muiTablePaginationOverrides,
	MuiButton: muiButtonOverrides,
	MuiOutlinedInput: muiOutlinedInputOverrides,
	MuiInputBase: muiInputBaseOverrides,
	MuiInputLabel: muiInputLabelOverrides,
	MuiFormControl: muiFormControlOverrides,
	MuiSwitch: muiSwitchOverrides,
	MuiFormGroup: muiFormGroupOverrides,
	MuiFormLabel: muiFormLabelOverrides,
	MuiFormControlLabel: muiFormControlLabelOverrides,
	MuiList: muiListOverrides,
	MuiListItem: muiListItemOverrides,
	MuiAlert: muiAlertOverrides,
	MuiAlertTitle: muiAlertTitleOverrides,
	MuiDrawer: muiDrawerOverrides,
	MuiTypography: muiTypographyOverrides,
	MuiSelect: muiSelectOverrides,
	MuiCheckbox: muiCheckboxOverrides,
	MuiIconButton: muiIconButtonOverrides,
	MuiAvatar: muiAvatarOverrides,
	MuiMenuItem: muiMenuItemOverrides,
	MuiSvgIcon: muiIconOverrides,
	MuiAppBar: muiAppBarOverrides,
	MuiLink: muiLinkOverrides,
	MuiDivider: muiDividerOverrides,
	MuiPaper: muiPaperOverrides,
	MuiContainer: muiContainerOverrides,
	muiMenuListOverrides,
};
